import { collection, deleteDoc, doc, getDocs, orderBy, query } from "firebase/firestore";
import React, { useEffect, useState } from 'react';
import { HiChevronDoubleLeft, HiChevronDoubleRight, HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import LoadingSpinner from '../assets/LoadingSpinner';
import '../css/InventoryPriceLogs.css'; // Adjust path as necessary
import { db } from "../firebase-config";

const InventoryPriceLogs = () => {
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [changeLogs, setChangeLogs] = useState([]);
  const [filteredChangeLogs, setFilteredChangeLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
       // Pagination state
       const [currentPage, setCurrentPage] = useState(1);
       const itemsPerPage = 20; // Adjust this value for more/less items per page

  const handleSearchChange = (e) => {
    const searchTerm = e.target.value;
    setSearch(searchTerm);
    filterChangeLogs(searchTerm, dateFrom, dateTo);
  };

  const handleDateFromChange = (e) => {
    const date = e.target.value;
    setDateFrom(date);
    filterChangeLogs(search, date, dateTo);
  };

  const handleDateToChange = (e) => {
    const date = e.target.value;
    setDateTo(date);
    filterChangeLogs(search, dateFrom, date);
  };

  const filterChangeLogs = (searchTerm, dateFrom, dateTo) => {
    let filteredLogs = changeLogs;

    // Filter by search term across three fields
    if (searchTerm.trim() !== '') {
      filteredLogs = filteredLogs.filter(log =>
        log.itemName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        log.typeOfChange.toLowerCase().includes(searchTerm.toLowerCase()) ||
        log.supplierName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        log.lastUpdatedBy.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Filter by date range if provided
    if (dateFrom) {
      filteredLogs = filteredLogs.filter(log => new Date(log.date) >= new Date(dateFrom));
    }
    if (dateTo) {
      filteredLogs = filteredLogs.filter(log => new Date(log.date) <= new Date(dateTo));
    }

    setFilteredChangeLogs(filteredLogs);
  };

  const handleEditClick = (id) => {
    console.log('Editing change log with ID:', id);
    // Navigate to the Edit Change Log page (you can define the route and page)
    navigate(`/pages/editChangeLog/${id}`);
  };

  const showInfo = async () => {
    const information = await Swal.fire({
      text: "Logs expire and will be automatically removed after 14 months of storage",
      icon: 'info',
    });
  }

  useEffect(() => {
    const fetchLogs = async () => {
        try {
          const logsQuery = query(
            collection(db, 'price_logs'),
            orderBy('dateTime', 'desc') // Sort by date in descending order
          );

        const querySnapshot = await getDocs(collection(db, 'price_logs'));
        const changeLogsArray = querySnapshot.docs.map(doc => {
          const data = doc.data();
          const parsedDate = data.date instanceof Date ? data.date : new Date(data.date); // Handle date parsing

          const updatedDate = data.lastUpdatedBy ? data.lastUpdatedBy.split('@')[0] : data.lastUpdatedBy;

          return {
            id: doc.id,
            ...data,
            date: parsedDate, // Ensure 'date' is always a Date object
            lastUpdatedBy: updatedDate
          };
        });

        const currentDate = new Date();

        // Calculate one year ago
        const oneYearAgo = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 365);
  
        // Filter out suppliers older than 1 year
        const filteredChangeLogs = changeLogs.filter(price_logs => {
          return price_logs.date >= oneYearAgo;
        });
  
        // Delete old suppliers from Firestore
        const oldChangeLogsToDelete = changeLogs.filter(price_logs => price_logs.date < oneYearAgo);
  
        // Update state with filtered suppliers
        setChangeLogs(filteredChangeLogs);
  
        // Delete old suppliers
        oldChangeLogsToDelete.forEach(async (oldPriceLogs) => {
          try {
            await deleteDoc(doc(db, 'price_logs', oldPriceLogs.id));
            console.log(`Deleted price log ${oldPriceLogs.id} older than 1 year`);
          } catch (error) {
            console.error(`Error deleting price log ${oldPriceLogs.id}:`, error);
          }
        });

        changeLogsArray.sort((a, b) => b.date - a.date);
        setChangeLogs(changeLogsArray);
        setFilteredChangeLogs(changeLogsArray);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch change logs. Please try again later.');
        console.error('Error fetching change logs:', err);
        setLoading(false);
      }
    };
    fetchLogs();
  }, []);

        // Calculate paginated data
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = filteredChangeLogs.slice(indexOfFirstItem, indexOfLastItem);
      
        // Total pages
        const totalPages = Math.ceil(filteredChangeLogs.length / itemsPerPage);
      
        const handlePageChange = (newPage) => {
          if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
          }
        };
  
        
  if (loading) return <LoadingSpinner isVisible={true} />;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
    <div className="header-pricelogs">
      <h1 className="header-pricelogs">Price Logs</h1>
      <button onClick={showInfo} className="info-btn-orderhistory">
            i
          </button>
    </div>
    <div className="container-changelog">
      <div className="top-section-changelog">
        <div className="search-container-changelog">
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={handleSearchChange}
            className="search-box-changelog"
          />
          <input
            type="date"
            value={dateFrom}
            onChange={handleDateFromChange}
            className="search-box-changelog"
            placeholder="Date From"
          />
           <h5> to </h5>
          <input
            type="date"
            value={dateTo}
            onChange={handleDateToChange}
            className="search-box-changelog"
            placeholder="Date To"
          />
        </div>
      </div>

      <table className="changelog-table">
        <thead>
          <tr>
            <th>Supplier Name</th>
            <th>Item Name</th>
            <th>Type of Change</th>
            <th>User</th>
            <th>Date & Time</th>
            <th>Price Change Log</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map(log => (
            <tr key={log.id}>
              <td>{log.supplierName}</td>
              <td>{log.itemName}</td>
              <td>{log.typeOfChange}</td>
              <td>{log.lastUpdatedBy}</td>
              <td>{new Date(log.date).toLocaleDateString()} {new Date(log.date).toLocaleTimeString('en-US', {hour: '2-digit', minute: '2-digit', hour12: true})}</td>
              <td>{log.priceChangeLog}</td>
            </tr>
          ))}
        </tbody>
      </table>

       {/* Pagination Controls */}
       <div className="pagination-controls">
            <button className="paginationButton"
              onClick={() => handlePageChange(1)} 
              disabled={currentPage === 1}
            >
              <HiChevronDoubleLeft />
            </button>
            <button className="paginationButton"
              onClick={() => handlePageChange(currentPage - 1)} 
              disabled={currentPage === 1}
            >
              <HiChevronLeft />
            </button>
            <span>Page {currentPage} of {totalPages}</span>
            <button className="paginationButton"
              onClick={() => handlePageChange(currentPage + 1)} 
              disabled={currentPage === totalPages}
            >
              <HiChevronRight />
            </button>
            <button className="paginationButton"
              onClick={() => handlePageChange(totalPages)} 
              disabled={currentPage === totalPages}
            >
              <HiChevronDoubleRight />
            </button>
          </div>

    </div>
    </>
  );
};

export default InventoryPriceLogs;